module.exports = __webpack_public_path__ + "static/media/graphOff_326.b66ec6df.png";